var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4364 33.1431C15.5322 33.1431 5.07129 40.0881 5.07129 48.6553V52.5333C5.07129 54.0748 11.4574 57.0496 12.9979 57.105C13.68 57.1296 14.4619 57.1431 15.357 57.1431C24.0202 57.1431 36.5464 57.1431 46.4509 57.1431C48.7447 57.1431 51.0099 56.6558 53.1012 55.7135C53.3404 55.6057 53.5956 55.5391 53.8545 55.4972C55.9795 55.153 57.6427 53.9989 57.6427 52.5333V48.6553C57.6427 40.0881 47.1818 33.1431 34.2776 33.1431H28.4364Z",
    fill: "#E580B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0048 34.2435C41.1397 38.5212 36.625 41.7145 31.0713 41.7145C25.593 41.7145 21.1257 38.6073 19.2153 34.4171C22.0621 33.5974 25.2028 33.1431 28.5034 33.1431H34.3447C37.4043 33.1431 40.3267 33.5335 43.0048 34.2435Z",
    fill: "#F0C1D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.78 17.8053C42.7837 17.6802 42.7856 17.5547 42.7856 17.4288C42.7856 10.6436 37.413 5.14307 30.7856 5.14307C24.1582 5.14307 18.7856 10.6436 18.7856 17.4288C18.7856 17.5547 18.7874 17.6802 18.7911 17.8053C17.7517 18.4761 17.0713 19.5929 17.0713 20.8574C17.0713 22.462 18.1671 23.8289 19.7017 24.3482C21.1779 29.3747 27.0608 33.1431 30.7856 33.1431C34.5103 33.1431 40.3933 29.3747 41.8695 24.3482C43.4041 23.8289 44.4999 22.462 44.4999 20.8574C44.4999 19.5929 43.8194 18.4761 42.78 17.8053Z",
    fill: "#F0C1D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.6431,
    y: 29.7144,
    width: 10.2857,
    height: 6.28571,
    fill: "#F0C1D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6429 57.1429C16.2143 42.8572 21.9286 33.7144 21.9286 33.7144C3.07147 37.4286 3.35718 51.7144 3.35718 57.1429H15.6429Z",
    fill: "#BFD6E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3571 57.1429C46.7857 42.8572 41.0714 33.7144 41.0714 33.7144C59.9285 37.4286 59.6428 51.7144 59.6428 57.1429H47.3571Z",
    fill: "#BFD6E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6426 53.2354L24.9854 46.9411C24.7485 44.6727 22.8362 42.9497 20.5555 42.9497V42.9497C18.3042 42.9497 16.4069 44.6296 16.1343 46.8643L15.3569 53.2354",
    stroke: "#002E52",
    strokeWidth: 2.28571,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 42.2856L20.5 34.2856",
    stroke: "#002E52",
    strokeWidth: 2.28571,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 45.1428V34.2856",
    stroke: "#002E52",
    strokeWidth: 2.28571,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3574,
    cy: 53.143,
    r: 1.42857,
    fill: "#002E52",
    stroke: "#002E52",
    strokeWidth: 0.571429
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.643,
    cy: 53.143,
    r: 1.42857,
    fill: "#002E52",
    stroke: "#002E52",
    strokeWidth: 0.571429
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5001,
    cy: 48.5714,
    r: 4.28571,
    fill: "#002E52",
    stroke: "#002E52",
    strokeWidth: 0.571429
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5001,
    cy: 48.5714,
    r: 2.28571,
    fill: "#00457A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5405 48.7136L49.7793 51.9775L65.1515 69.6554L68.9127 66.3915L53.5405 48.7136Z",
    fill: "#7DAED4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.053 73.7498L72.0098 73.7872C70.8236 74.817 69.2346 74.9305 68.461 74.041L59.5352 63.9335L63.9108 59.9663L72.8009 70.2751C73.5745 71.1645 73.2398 72.7201 72.0536 73.7499L72.053 73.7498Z",
    fill: "#002E52"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1443 58.3444C61.7891 54.292 64.7049 44.8332 60.6569 37.2177C56.6088 29.6021 47.13 26.7136 39.4852 30.766C31.8404 34.8184 28.9246 44.2771 32.9726 51.8927C37.0207 59.5083 46.4995 62.3968 54.1443 58.3444Z",
    fill: "#002E52"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3498 55.7196C49.6102 57.6384 56.2406 54.1188 58.1594 47.8585C60.0781 41.5981 56.5586 34.9677 50.2982 33.0489C44.0379 31.1302 37.4074 34.6497 35.4887 40.9101C33.5699 47.1704 37.0895 53.8009 43.3498 55.7196Z",
    fill: "#7DAED4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.926 40.2856C56.6884 36.9402 53.9577 34.1889 50.2814 33.0622C44.0276 31.1454 37.4057 34.6556 35.4912 40.9023C35.018 42.4459 34.8766 44.0122 35.0263 45.5246L57.926 40.2856Z",
    fill: "#7DAED4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2473 59.2408L64.2473 59.2408L64.2839 59.2906C64.5277 59.6207 64.4813 60.0816 64.1776 60.357L64.2473 59.2408ZM64.2473 59.2408L64.2463 59.2394C63.9635 58.8566 63.41 58.8038 63.06 59.1274C63.06 59.1275 63.06 59.1275 63.06 59.1275L58.9289 62.9466L58.9289 62.9466C58.5997 63.251 58.5852 63.7654 58.8958 64.088L58.8958 64.088L58.8982 64.0905L58.9026 64.095C59.2024 64.4043 59.6945 64.4217 60.0145 64.1315C60.0145 64.1315 60.0145 64.1314 60.0145 64.1314C60.0146 64.1314 60.0146 64.1314 60.0146 64.1313L64.1775 60.357L64.2473 59.2408Z",
    fill: "#F0C1D9",
    stroke: "#F0C1D9",
    strokeWidth: 0.846844
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6258 46.2926L45.6174 46.2842C45.4185 46.0853 45.3104 45.8403 45.3104 45.561C45.3104 44.9688 45.4157 44.4357 45.6354 43.969C45.844 43.5256 46.0897 43.1508 46.3759 42.8511L46.3761 42.8509C46.6604 42.5536 47.0304 42.2225 47.4828 41.858L47.485 41.8563L47.485 41.8563C47.9499 41.4892 48.2789 41.1814 48.4832 40.9318C48.6655 40.709 48.7536 40.4625 48.7536 40.1821C48.7536 39.5738 48.5582 39.1602 48.2008 38.8877C47.8287 38.6041 47.2368 38.439 46.3778 38.439C45.9683 38.439 45.5648 38.4917 45.1667 38.597L45.1609 38.5986L45.1609 38.5985C44.779 38.6911 44.4427 38.8284 44.1492 39.0084C43.96 39.1334 43.7521 39.2021 43.5301 39.2021C43.2509 39.2021 43.0058 39.094 42.807 38.8951M45.6258 46.2926L42.807 38.8951C42.807 38.8951 42.807 38.8951 42.807 38.8951M45.6258 46.2926L45.6349 46.3003M45.6258 46.2926L45.6349 46.3003M42.807 38.8951C42.6081 38.6962 42.4999 38.4512 42.4999 38.1719C42.4999 37.7599 42.7329 37.4433 43.1008 37.2216C43.6306 36.8859 44.1716 36.6442 44.7234 36.4996C45.2718 36.356 45.8736 36.2856 46.5267 36.2856C47.8395 36.2856 48.9216 36.6143 49.7429 37.3006C50.5836 37.9926 51.0002 38.9326 51.0002 40.089C51.0002 40.6073 50.907 41.0778 50.7128 41.4941M42.807 38.8951L50.7128 41.4941M45.6349 46.3003C45.8538 46.4855 46.1201 46.5726 46.415 46.5726C46.7018 46.5726 46.9606 46.483 47.1766 46.3003L47.1767 46.3005L47.1858 46.2921C47.3988 46.0955 47.5197 45.8482 47.5197 45.561C47.5197 45.1173 47.635 44.7666 47.8499 44.49C48.1036 44.1672 48.4877 43.7986 49.0116 43.3843C49.426 43.0578 49.7642 42.7648 50.0231 42.5059L50.0232 42.506L50.028 42.5009C50.2987 42.2166 50.526 41.8811 50.7112 41.4975L50.7112 41.4975M45.6349 46.3003L50.7112 41.4975M50.7112 41.4975L50.7128 41.4941M50.7112 41.4975L50.7128 41.4941M45.4256 50.7005L45.4312 50.7064L45.4371 50.7121C45.7117 50.9713 46.0418 51.1065 46.415 51.1065C46.7976 51.1065 47.1319 50.9732 47.3988 50.7064C47.6746 50.4305 47.8175 50.0915 47.8175 49.704C47.8175 49.3275 47.6735 49.0008 47.3988 48.7388C47.1342 48.4616 46.8002 48.3202 46.415 48.3202C46.0365 48.3202 45.7046 48.4656 45.4313 48.7389C45.1669 49.0033 45.0312 49.3303 45.0312 49.704C45.0312 50.0864 45.164 50.4236 45.4256 50.7005Z",
    fill: "#002E52",
    stroke: "#002E52",
    strokeWidth: 0.571429
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDoctor);
export default __webpack_public_path__ + "static/media/NoDoctor.07aa5efac0630bd51f84976d2aefd43b.svg";
export { ForwardRef as ReactComponent };